// extracted by mini-css-extract-plugin
module.exports = {"small":"TotalItems_small__lLh4e","inverse":"TotalItems_inverse__SkVbM"};